import { prefersReducedMotion } from './motion-utils'

export function animateValue(
  obj,
  startSymbol,
  startValue,
  endSymbol,
  endValue,
  duration
) {
  const currentSymbol = startSymbol || endSymbol

  // If user prefers reduced motion, show final value instantly
  if (prefersReducedMotion()) {
    obj.textContent = currentSymbol + endValue.toFixed(2)
    return
  }

  let startTimestamp = null
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp
    const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    obj.textContent =
      currentSymbol +
      (startValue + progress * (endValue - startValue)).toFixed(2)
    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }
  window.requestAnimationFrame(step)
}

export function extractCurrencyAndValue(str) {
  const match = str.match(/([^\d.-]+)?([\d.-]+)/)
  if (match) {
    return { symbol: match[1] || '', value: parseFloat(match[2]) }
  }
  return { symbol: '', value: 0 }
}
